import React from 'react';

import { List } from '../../components';
import { ListContainer } from '../../containers';
import { useRefreshPage } from '../../hooks/useRefreshPage';

import PointOfSaleListItem from './PointOfSaleListItem';

const PointOfSaleList = ({
	items,
	refetch,
	customProps,
}) => {
	const [refreshPage, isRefreshing] = useRefreshPage(refetch);

	return (
		<List
			items={items}
			listItemComponent={PointOfSaleListItem}
			onRefresh={refreshPage}
			isRefreshing={isRefreshing}
			emptyListMessage="No points of sale to display"
			autoScrollTop={true}
			showControls={true}
			removeTopMargin={true}
			customProps={customProps}
			assembler={[
				{ label: 'ID', sortBy: 'assetId' },
			]}
		/>
	);
};

export default ListContainer(PointOfSaleList);
